import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Printer } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import { openPopUpWindow } from '@bibliocommons/utils-browser';

const PRINT_WINDOW_NAME = 'printWindow';

function handleClick(e, url) {
  if (e.target && typeof e.target.blur === 'function') {
    e.target.blur();
  }

  // This is to prevent Microsoft Edge from exploding
  function stopFocus(focusEvent) {
    focusEvent.preventDefault();
    window.removeEventListener('focus', stopFocus);
  }
  window.addEventListener('focus', stopFocus);

  openPopUpWindow({ url, PRINT_WINDOW_NAME });
}

function PrintButton({ url, iconColor, className }) {
  return (
    <DefaultButton
      className={`cp-print-button ${className}`}
      dataKey="print-view-button"
      href={url}
      tagName="a"
      rel="nofollow"
      flat
      handleClick={e => handleClick(e, url)}
    >
      <Printer color={iconColor} />
      <ScreenReaderMessage>
        <FormattedMessage id="print_view" />
      </ScreenReaderMessage>
    </DefaultButton>
  );
}

PrintButton.propTypes = {
  className: PropTypes.string,
  iconColor: PropTypes.string,
  url: PropTypes.string.isRequired
};

export default PrintButton;
